import { FileUpload, Float } from "@chakra-ui/react"
import { FiTrash2 } from "react-icons/fi"

interface FileUploadListProps {
  file: File
  path: string | null
  onClick: () => void | null
}


const FileUploadList = ({file, path, onClick} : FileUploadListProps) => {

  return (
    <FileUpload.ItemGroup>
      <FileUpload.Item
        w="auto"
        boxSize="20"
        p="2"
        borderRadius="full"
        backgroundColor="unset"
        pos="relative"
        overflow="hidden"
        display="flex"
        alignItems="center"
        justifyContent="center"
        key={file.name}
        file={file}
        data-testid="file_upload_item"
      >
        <FileUpload.ItemPreviewImage
          src={path ?? undefined}
          alt="preview"
          height="full"
          width="full"
          pos="absolute"
          zIndex={-1}
          left={0}
          objectFit="cover"
        />

        <Float
          placement="middle-center"
          w="100%"
          h="100%"
          opacity={0}
          _hover={{ opacity: 1 }}
          pos="absolute"
          borderRadius="inherit"
          backgroundColor="#ffffff90"
          flexWrap="wrap"
          alignContent="center"
          cursor="pointer"
          >
          <FileUpload.ItemDeleteTrigger
            color="danger"
            fontSize={40}
            width="inherit"
            height="inherit"
            onClick={onClick}
          >
            <FiTrash2 />
          </FileUpload.ItemDeleteTrigger>
        </Float>
      </FileUpload.Item>
    </FileUpload.ItemGroup>
  )
}

export default FileUploadList
